import React, {useContext, useEffect} from "react";
import {ErrorDialogType, useErrorDialog } from "../../../utils/hooks/useErrorDialog";
import {forms} from '../forms'
import { StepProps } from "../../QuotationForm/step-props";
import { ErrorMessageDialog } from "../../../components/dialogs/ErrorMessageDialog";
import {SelectProgramForm} from "../forms/SelectProgramForm";
import { useTravelTariffication } from "./hooks/useTravelTariffication";
import {ITravelQuotationContext, TravelQuotationContext} from "../../../contexts/TravelQuotationContext";

export const TravelTarifficationStep = ({step}: StepProps) => {
    const {setCurrentStep} = useContext<ITravelQuotationContext>(TravelQuotationContext);
    useEffect(() => {
        setCurrentStep("travel_online_00001")
    }, [])
    const {
        textErrorMessageDialog, setTextErrorMessageDialog,
        openErrorMessageDialog, setOpenErrorMessageDialog,
        textDetailErrorMessageDialog, setTextDetailErrorMessageDialog
    } = useErrorDialog();

    const {
        tariffied,
        packages,
        onPackageSelect,
        onRecalculate,
        onFormSubmit,
        onSumInsuredSelect
    } = useTravelTariffication("travel_online_00001", setTextErrorMessageDialog, setTextDetailErrorMessageDialog, setOpenErrorMessageDialog);


    return (
        <>
            {tariffied && (
                <SelectProgramForm packages={packages}
                                   onSumInsuredSelect={onSumInsuredSelect}
                                   onPackageSelect={onPackageSelect}
                                   onBackStep={onRecalculate}/>
            )}

            {!tariffied && (
                step.forms.map(form => {
                    return React.createElement(forms[form.code], {
                        key: form.code,
                        onFormSubmit
                    })
                })
            )}

            <ErrorMessageDialog type={ErrorDialogType.ERROR}
                                text={textErrorMessageDialog}
                                open={openErrorMessageDialog}
                                onClickListener={() => setOpenErrorMessageDialog(false)}
                                textDetail={textDetailErrorMessageDialog}/>
        </>
    );
};